module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/images/logo404-0503ce.png";